import { Box, Typography } from "@mui/material";
import { useTheme } from "../../components/context/context";
import Downloader from "../../components/pdf_downloader/Downloader";

export default function NewsLetter(){
    const {fontSize} = useTheme();
    return(
        <Box sx={{}}>
            <Typography variant="h1" sx={{fontSize:`${fontSize+0.5}rem`, margin:"5px 0"}}>News Letter</Typography>
            <hr/>
            <Box sx={{borderLeft:"5px solid #0b4285", padding:"2px 0 2px 10px", marginTop:"20px", backgroundColor:"whitesmoke"}}>
            <span style={{fontWeight:"bold",fontSize:`${fontSize}rem`}}>MSSAT Newsletter 2025-26 Apr-Jun 1st Edition </span>
                <Downloader url={"pdf/NewsLetter/MSSAT Newsletter 2025-26 (Apr-Jun) 1st Edition.pdf"} name={"MSSAT Newsletter 2025-26 (Apr-Jun) 1st Edition"}/> 
            <span style={{fontWeight:"bold",fontSize:`${fontSize}rem`}}>MSSAT Newsletter 2024-25 2nd Edition </span>
                <Downloader url={"pdf/NewsLetter/MSSAT Newsletter 2024-25 2nd Edition.pdf"} name={"MSSAT Newsletter 2024-25 2nd Edition"}/> 
            <span style={{fontWeight:"bold",fontSize:`${fontSize}rem`}}>MSSAT NewsLetter 2024-25 Vol-I </span>
                <Downloader url={"pdf/NewsLetter/MSSAT Newsletter 2024-25 Vol I.pdf"} name={"NMSSAT NewsLetter 2024-25 Vol-I"}/> 
            <span style={{fontWeight:"bold",fontSize:`${fontSize}rem`}}>MSSAT NewsLetter First Edition 2023-24 </span>
                <Downloader url={"pdf/NewsLetter/MSSAT Newsletter (First Edition) 2023-24.pdf"} name={"MSSAT NewsLetter First Edition 2023-24"}/> 
            </Box>
        </Box>
    )
}